import { Avatar, Button, DatePicker, Input, Radio } from 'antd'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import { createValue } from 'components/form/utils'
import { Formik } from 'formik'
import { parseDayjs } from 'helpers/datetimeHelpers'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, { useMemo } from 'react'
import { BsImage, BsPeopleFill, BsPersonCircle } from 'react-icons/bs'
import { IoCalendarOutline } from 'react-icons/io5'
import { compose, mapProps } from 'recompose'
import { GenderTypes, IdentifierTypes } from 'views/AppLocals/appFieldTypes'
import { gConfigs } from 'views/AppLocals/configs'
import { ErrorSummaries } from 'views/AppLocals/factory/createEditableForm'
import { createControlledFormField } from 'views/AppLocals/factory/createFormField'
import { NullAsDefault, shallowDiff } from 'views/Shared'
import Translate from '../../../../modules/local/Translate'
import AvatarUploader from '../../../Workspace/components/AvatarUploader'
import { appClassNames } from '../../custom/appClassNames'
import IdentifierCodeLookupField from '../../../../components/IdentifierCodeLookupField'
import { LayoutContext } from '../../../../components/layouts/Default/LayoutContext'
import LookupField from '../../../../components/LookupField'
import { renderIf, renderIfElse } from '../../../Shared'
import { RiMapPinFill, RiSearch2Line } from 'react-icons/ri'
import { MdChurch } from 'react-icons/md'
import { SaintsOutlineSvg } from '../../../../components/Svgs/SaintsPlaceholder'
import UserLookupComponent from '../../../../components/UserLookupComponent'
import Pure from '../../../../components/Pure'
import ForDevelop from '../../../../envs/ForDevelop'
import { ReligiousFillSvg } from '../../../../components/Svgs/ReligiousIconSvg'
import dayjs from 'dayjs'
import { ActionModalWrapper } from '../../../../components/form/ActionModalWrapper'
import { FaPhone, FaUserGraduate } from 'react-icons/fa6'
import {
  digitLength,
  emailFormat,
  firstLetterUppercase,
  lengthBetween,
  noDoubleSpaces,
  noLeadingTrailingSpaces,
  noNumber,
  noSpecialChars,
  parishFormart,
  passportFormart,
  required,
  runRules,
} from '../../../../components/form/ValidateForm'
// import { error } from 'tailwindcss/lib/cli/utils'

export const formSchema = {
  contact_email__phone: {
    inline: true,
    className: appClassNames.inline_2,
    children: [
      {
        label: 'email',
        name: 'contact_email',
        component: createControlledFormField({
          type: 'email',
          placeholder: 'ex: email',
          autoComplete: false,
          Component: Input,
        }),
      },
      {
        label: 'phone',
        name: 'contact_phone',
        component: createControlledFormField({
          type: 'tel',
          placeholder: 'ex: phone',
          autoComplete: false,
          Component: Input,
        }),
      },
    ],
  },

  contact_email: {
    title: 'email',
    children: [
      {
        name: 'contact_email',
        component: createControlledFormField({
          type: 'email',
          placeholder: 'ex: email',
          autoComplete: false,
          Component: Input,
        }),
      },
    ],
  },
  contact_phone: {
    title: 'phone',
    children: [
      {
        name: 'contact_phone',
        component: createControlledFormField({
          type: 'tel',
          placeholder: 'ex: phone',
          autoComplete: false,
          Component: Input,
        }),
      },
    ],
  },

  contact_address: {
    title: 'address',
    children: [
      {
        name: 'contact_address',
        component: createControlledFormField({
          showCount: true,
          maxLength: 500,
          placeholder: 'ex: address',
          autoComplete: false,
          Component: Input,
        }),
      },
    ],
  },
  patron_saint__fullname: {
    inline: true,
    className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
    itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
    children: [
      {
        label: 'holy name',
        name: 'patron_saint',
        component: ({ name, value, onChange, form }) => (
          <Translate>
            {(t) => (
              <LookupField
                title={t('choose patron saint')}
                createIfNotExists={true}
                defaultValue={form?.values?.patron_saint_name}
                selectedOption={form?.values?.patron_saint}
                apiPath={`/lookup/saint/get-by-types`}
                name={name}
                OptionWrapper={({ children, ...props }) => (
                  <div
                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative"
                    {...props}>
                    {children}
                  </div>
                )}
                renderOption={(o, i) => {
                  return (
                    <div
                      key={i}
                      className="flex items-center flex-1 gap-3">
                      <Avatar
                        size={50}
                        src={o.avatar}
                        className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                        icon={
                          <SaintsOutlineSvg
                            size={30}
                            style={{ color: '#dddddd' }}
                          />
                        }
                      />
                      <div className="flex flex-col flex-1">
                        <span className="font-bold text-sm text-color-000 leading-snug">
                          {`${o.common_name || o.name} (${
                            o.patron_saint_feast_day || o.feast_day
                          })`}
                        </span>
                        {renderIf(
                          o?.description,
                          <span className="text-xs text-color-400 italic max-lines-1">
                            {o?.description}
                          </span>
                        )}
                      </div>
                    </div>
                  )
                }}
                handleChange={(e) => {
                  form.setValues({
                    ...form.values,
                    patron_saint: e.target,
                    patron_saint_name: e.target.common_name || e.target.value,
                    patron_saint_feast_day: e.target.feast_day,
                    patron_saint_id: e.target.id,
                  })
                }}
              />
            )}
          </Translate>
        ),
      },
      {
        label: 'fullname',
        name: 'fullname',
        required: true,
        component: ({ name, value, form, onChange }) => (
          <Translate>
            {(t) => (
              <div className="flex flex-col gap-1">
                <Input.Group
                  compact
                  style={{ display: 'inline-flex', alignItems: 'center' }}
                  className="custom-input-group">
                  <Input
                    name={name}
                    value={value}
                    onChange={onChange}
                    allowClear={true}
                    placeholder={t('Enter your name')}
                    style={{ borderRadius: '0.375rem 0 0 0.375rem' }}
                    className="flex-1"
                  />
                  <UserLookupComponent
                    handleApply={(userInfo) => {
                      const { values, setValues } = form ?? {}
                      const {
                        name,
                        email,
                        gender,
                        phone_number,
                        identifier_type,
                        identifier_code,
                        date_of_birth,
                        place_of_birth,
                        address,
                        patron_saint,
                        patron_saint_name,
                        parish,
                        parish_name,
                        diocese,
                        diocese_name,
                        religious_order,
                      } = userInfo ?? {}

                      const user_info = _.omitBy(
                        {
                          email,
                          gender: _.find(GenderTypes, { value: gender })?.value,
                          date_of_birth: !!String(date_of_birth ?? '').length
                            ? parseDayjs(date_of_birth)
                            : undefined,
                          place_of_birth: place_of_birth ?? undefined,
                          fullname: !!String(name ?? '').length
                            ? name
                            : undefined,
                          contact_phone: phone_number
                            ? phone_number
                            : undefined,
                          contact_email: email ?? undefined,
                          contact_address: address ?? undefined,

                          identifier_type: _.find(IdentifierTypes, {
                            value: identifier_type,
                          })?.value,
                          identifier_code: !!String(identifier_code ?? '')
                            .length
                            ? identifier_code
                            : undefined,

                          user: userInfo,
                          user_id: userInfo?.id,

                          patron_saint: patron_saint,
                          patron_saint_id: patron_saint?.id,
                          patron_saint_name: patron_saint_name,

                          diocese_id: diocese?.id,
                          diocese_name: diocese_name,
                          diocese: diocese,

                          parish_id: parish?.id,
                          parish_name: parish_name,
                          parish: parish,

                          religious_order: religious_order,
                          religious_order_id: religious_order?.id,
                          religious_order_name: userInfo?.religious_order_name,
                        },
                        _.isUndefined
                      )
                      setValues({
                        ...values,
                        ...(user_info ?? {}),
                        refreshKey: Date.now(),
                      })
                    }}>
                    <Button
                      type="primary"
                      style={{ width: 46, border: '1px solid transparent' }}
                      icon={
                        <RiSearch2Line
                          size={14}
                          className="hover:opacity-85 cursor-pointer"
                        />
                      }
                      className="flex flex-center"
                    />
                  </UserLookupComponent>
                </Input.Group>
                <span className="text-xs text-color-500 italic leading-tight">
                  {`* `}
                  {t(
                    'click on {n} to, lookup user accounts on the {m} platform',
                    {
                      n: (
                        <RiSearch2Line
                          size={13}
                          className="mx-1 text-color-000"
                        />
                      ),
                      m: (
                        <span className="font-bold text-blue-600 tracking-widest">
                          {'Kristo Network'}
                        </span>
                      ),
                    }
                  )}
                </span>
              </div>
            )}
          </Translate>
        ),
      },
    ],
  },
  father_user: {
    inline: true,
    className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
    itemClassNames: ['col-span-1 md:col-span-2', 'col-span-1'],
    children: [
      {
        label: 'father',
        name: 'father_name',
        required: true,
        component: ({ name, value, form, onChange }) => (
          <Translate>
            {(t) => (
              <div className="flex flex-col gap-1">
                <Input.Group
                  compact
                  style={{ display: 'inline-flex', alignItems: 'center' }}
                  className="custom-input-group">
                  <Input
                    name={name}
                    value={value}
                    onChange={onChange}
                    autoComplete={false}
                    allowClear={true}
                    placeholder={t('Enter your name')}
                    style={{ borderRadius: '0.375rem 0 0 0.375rem' }}
                    className="flex-1"
                  />
                  <UserLookupComponent
                    handleApply={(userInfo) => {
                      const { values, setValues } = form ?? {}
                      const { name, phone_number } = userInfo ?? {}

                      const user_info = _.omitBy(
                        {
                          father_name: !!String(name ?? '').length
                            ? name
                            : undefined,
                          father_phone_number: phone_number
                            ? phone_number
                            : undefined,
                          father_user: userInfo,
                          father_user_id: userInfo?.id,
                        },
                        _.isUndefined
                      )
                      setValues({
                        ...values,
                        ...(user_info ?? {}),
                        refreshKey: Date.now(),
                      })
                    }}>
                    <Button
                      type="primary"
                      style={{ width: 46, border: '1px solid transparent' }}
                      icon={
                        <RiSearch2Line
                          size={14}
                          className="hover:opacity-85 cursor-pointer"
                        />
                      }
                      className="flex flex-center"
                    />
                  </UserLookupComponent>
                </Input.Group>
                <span className="text-xs text-color-500 italic leading-tight">
                  {`* `}
                  {t(
                    'click on {n} to, lookup user accounts on the {m} platform',
                    {
                      n: (
                        <RiSearch2Line
                          size={13}
                          className="mx-1 text-color-000"
                        />
                      ),
                      m: (
                        <span className="font-bold text-blue-600 tracking-widest">
                          {'Kristo Network'}
                        </span>
                      ),
                    }
                  )}
                </span>
              </div>
            )}
          </Translate>
        ),
      },
      {
        label: 'phone',
        name: 'father_phone_number',
        component: createControlledFormField({
          type: 'tel',
          placeholder: 'ex: phone',
          Component: Input,
          autoComplete: false,
        }),
      },
    ],
  },

  mother_user: {
    inline: true,
    className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
    itemClassNames: ['col-span-1 md:col-span-2', 'col-span-1'],
    children: [
      {
        label: 'mother',
        name: 'mother_name',
        required: true,
        component: ({ name, value, form, onChange }) => (
          <Translate>
            {(t) => (
              <div className="flex flex-col gap-1">
                <Input.Group
                  compact
                  style={{ display: 'inline-flex', alignItems: 'center' }}
                  className="custom-input-group">
                  <Input
                    name={name}
                    value={value}
                    onChange={onChange}
                    allowClear={true}
                    autoComplete={false}
                    placeholder={t('Enter your name')}
                    style={{ borderRadius: '0.375rem 0 0 0.375rem' }}
                    className="flex-1"
                  />
                  <UserLookupComponent
                    handleApply={(userInfo) => {
                      const { values, setValues } = form ?? {}
                      const { name, phone_number } = userInfo ?? {}

                      const user_info = _.omitBy(
                        {
                          mother_name: !!String(name ?? '').length
                            ? name
                            : undefined,
                          mother_phone_number: phone_number
                            ? phone_number
                            : undefined,
                          mother_user: userInfo,
                          mother_user_id: userInfo?.id,
                        },
                        _.isUndefined
                      )
                      setValues({
                        ...values,
                        ...(user_info ?? {}),
                        refreshKey: Date.now(),
                      })
                    }}>
                    <Button
                      type="primary"
                      style={{ width: 46, border: '1px solid transparent' }}
                      icon={
                        <RiSearch2Line
                          size={14}
                          className="hover:opacity-85 cursor-pointer"
                        />
                      }
                      className="flex flex-center"
                    />
                  </UserLookupComponent>
                </Input.Group>
                <span className="text-xs text-color-500 italic leading-tight">
                  {`* `}
                  {t(
                    'click on {n} to, lookup user accounts on the {m} platform',
                    {
                      n: (
                        <RiSearch2Line
                          size={13}
                          className="mx-1 text-color-000"
                        />
                      ),
                      m: (
                        <span className="font-bold text-blue-600 tracking-widest">
                          {'Kristo Network'}
                        </span>
                      ),
                    }
                  )}
                </span>
              </div>
            )}
          </Translate>
        ),
      },
      {
        label: 'phone',
        name: 'mother_phone_number',
        component: createControlledFormField({
          type: 'tel',
          placeholder: 'ex: phone',
          Component: Input,
          autoComplete: false,
        }),
      },
    ],
  },

  date__place_of_birth_gender: {
    inline: true,
    className: appClassNames.inline_3,
    children: [
      {
        label: 'date of birth',
        name: 'date_of_birth',
        component: compose(
          withTranslate,
          mapProps(({ name, value, onChange, translate }) => ({
            name,
            value,
            className: 'w-full',
            format: gConfigs.dateFormat,
            suffixIcon: <IoCalendarOutline className="text-color-500" />,
            placeholder: `${translate('date of birth')} "DD/MM/YYYY"`,
            // 🔹 Giới hạn ngày
            disabledDate: (current) => {
              const maxDate = dayjs().subtract(4, 'year')
              const minDate = dayjs().subtract(120, 'year')

              return (
                current &&
                (current > maxDate.endOf('day') ||
                  current < minDate.startOf('day'))
              )
            },
            // 🔹 mở lịch ở khoảng năm hợp lý
            defaultPickerValue: dayjs().subtract(4, 'year'),
            onChange: (date, dateString) => {
              onChange(createValue(name, date ? dayjs(new Date(date)) : null))
            },
          }))
        )(DatePicker),
      },
      {
        label: 'place of birth',
        name: 'place_of_birth',
        component: ({ name, value, onChange, form, ...restForm }) => {
          return (
            <Translate>
              {(t) => (
                <LookupField
                  title={t('choose place of birth')}
                  createIfNotExists={true}
                  defaultValue={form?.values?.place_of_birth}
                  selectedOption={form?.values?.birth_province}
                  apiPath={`/lookup/province/get-by-types`}
                  name={name}
                  OptionWrapper={({ children, ...props }) => (
                    <div
                      className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative"
                      {...props}>
                      {children}
                    </div>
                  )}
                  renderOption={(o, i) => (
                    <div
                      key={i}
                      className="flex items-center flex-1 gap-3">
                      <div className="p-2 font-bold text-sm text-color-000 leading-tight">
                        {o.location_name}
                      </div>
                    </div>
                  )}
                  handleChange={(e) => {
                    form.setValues({
                      ...form.values,
                      place_of_birth: e.target.value,
                    })
                  }}
                />
              )}
            </Translate>
          )
        },
      },
      {
        label: 'gender',
        name: 'gender',
        component: compose(
          withTranslate,
          mapProps(({ name, value, onChange, translate }) => ({
            name,
            value,
            onChange,
            buttonStyle: 'solid',
            className: 'w-full custom-radio-button',
            children: Object.values(GenderTypes).map(
              ({ name, value, label }) => (
                <Radio.Button
                  style={{ padding: '0px 10px' }}
                  key={name}
                  value={value}>
                  {translate(label)}
                </Radio.Button>
              )
            ),
          }))
        )(Radio.Group),
      },
    ],
  },
  identifier: {
    inline: true,
    className: appClassNames.inline_2,
    children: [
      {
        label: 'identifier type',
        name: 'identifier_type',
        component: compose(
          withTranslate,
          mapProps(({ name, value, onChange, translate }) => ({
            name,
            value,
            onChange,
            buttonStyle: 'solid',
            className: 'w-full custom-radio-button',
            children: Object.values(IdentifierTypes).map(
              ({ name, value, label }) => (
                <Radio.Button
                  style={{ padding: '0px 10px' }}
                  key={name}
                  value={value}>
                  {translate(label)}
                </Radio.Button>
              )
            ),
          }))
        )(Radio.Group),
      },
      {
        label: 'identifier code',
        name: 'identifier_code',
        component: createControlledFormField({
          placeholder: 'identifier code',
          Component: Input,
        }),
      },
    ],
  },
  id_validator: {
    inline: true,
    className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
    // itemClassNames: ['flex-1', ''],
    children: [
      {
        label: 'identifier code',
        name: 'identifier_code',
        required: true,
        className: 'flex-1',
        component: compose(
          withTranslate,
          mapProps(({ name, value, form, translate, onChange }) => {
            return {
              name,
              onChange,
              type: 'id code',
              placeholder: translate('ex: id code'),
              defaultValue: value,
              params: {
                ...{
                  owner_type: form?.values?.owner_type,
                  owner_id: form?.values?.owner_id,
                },
                search_type: 'user',
                input_type: 'identifier_code',
              },
              handleApply: (info) => {
                const { values, setValues } = form ?? {}
                const { identifier_type, identifier_code } = info ?? {}
                const user_info = _.omitBy(
                  {
                    identifier_type: _.find(IdentifierTypes, {
                      value: identifier_type,
                    })?.value,
                    identifier_code: !!String(identifier_code ?? '').length
                      ? identifier_code
                      : undefined,
                    user: info,
                    user_id: info?.id,
                  },
                  _.isUndefined
                )
                setValues({
                  ...values,
                  ...(user_info ?? {}),
                })
              },
            }
          })
        )(IdentifierCodeLookupField),
      },
      {
        label: 'identifier type',
        name: 'identifier_type',
        component: compose(
          withTranslate,
          mapProps(({ name, value, onChange, translate }) => ({
            name,
            value,
            onChange,
            buttonStyle: 'solid',
            className: 'w-full whitespace-no-wrap custom-radio-button',
            children: Object.values(IdentifierTypes).map(
              ({ name, value, label }) => (
                <Radio.Button
                  key={name}
                  style={{ padding: '0px 10px', height: 32 }}
                  value={value}>
                  {translate(label)}
                </Radio.Button>
              )
            ),
          }))
        )(Radio.Group),
      },
    ],
  },
  avatar: {
    children: [
      {
        name: 'avatar',
        component: createControlledFormField({
          withValues: ({ avatar_preview }) => ({
            value: avatar_preview,
            width: 150,
            height: 150,
            icon: (
              <BsImage
                size={70}
                style={{ color: '#eaeaea' }}
              />
            ),
          }),
          Component: AvatarUploader,
        }),
      },
    ],
  },
  diocese_location: {
    inline: true,
    className: 'grid grid-cols-2 gap-3',
    children: [
      {
        label: 'belong to parish',
        name: 'parish',
        component: ({ name, value, onChange, form, ...restForm }) => {
          return (
            <LayoutContext.Consumer>
              {({ isSm }) => (
                <Translate>
                  {(t) => (
                    <LookupField
                      title={t('choose parish')}
                      createIfNotExists={true}
                      defaultValue={form?.values?.parish_name}
                      selectedOption={form?.values?.parish}
                      placeholder={t('click to select / create')}
                      apiPath={`/lookup/parish/get-by-types`}
                      name={name}
                      OptionWrapper={({ children, ...props }) => (
                        <div
                          className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative"
                          {...props}>
                          {children}
                        </div>
                      )}
                      renderOption={(o, i) => {
                        const { fullname, diocese_fullname, location_address } =
                          o ?? {}
                        return (
                          <div
                            key={i}
                            className="flex items-center flex-1 gap-3">
                            {renderIf(
                              !isSm,
                              <Avatar
                                size={50}
                                src={o.avatar}
                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                icon={
                                  <MdChurch
                                    size={20}
                                    style={{ color: '#dddddd' }}
                                  />
                                }
                              />
                            )}
                            <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                              <div className="space-x-1 leading-snug">
                                <span className="font-bold text-sm text-color-000">
                                  {fullname}
                                </span>
                                <span className="font-medium text-xs text-blue-500 italic leading-snug">
                                  {`( ${diocese_fullname} )`}
                                </span>
                              </div>
                              {renderIf(
                                location_address,
                                <div className="flex items-center gap-x-1">
                                  <RiMapPinFill
                                    size={11}
                                    className="text-color-400"
                                  />
                                  <span className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                    {location_address}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      }}
                      handleChange={(e) => {
                        form.setValues({
                          ...form.values,
                          parish: e.target,
                          parish_name: e.target.value,
                          parish_id: e.target.id,
                          diocese: e.target.diocese,
                          diocese_name: e.target?.diocese?.name,
                          diocese_id: e.target?.diocese?.id,
                        })
                      }}
                    />
                  )}
                </Translate>
              )}
            </LayoutContext.Consumer>
          )
        },
      },
      {
        label: 'diocese',
        name: 'diocese',
        component: ({ name, value, onChange, form, ...restForm }) => {
          return (
            <LayoutContext.Consumer>
              {({ isSm }) => (
                <Translate>
                  {(t) => (
                    <LookupField
                      title={t('choose diocese')}
                      createIfNotExists={true}
                      defaultValue={form?.values?.diocese_name}
                      selectedOption={form?.values?.diocese}
                      apiPath={`/lookup/diocese/get-by-types`}
                      name={name}
                      OptionWrapper={({ children, ...props }) => (
                        <div
                          className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative"
                          {...props}>
                          {children}
                        </div>
                      )}
                      renderOption={(o, i) => {
                        const { fullname, location_address } = o ?? {}
                        return (
                          <div
                            key={i}
                            className="flex items-center flex-1 gap-3">
                            <Avatar
                              size={50}
                              src={o.avatar}
                              className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                              icon={
                                <MdChurch
                                  size={20}
                                  style={{ color: '#dddddd' }}
                                />
                              }
                            />
                            <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                              <div className="space-x-1 leading-snug">
                                <span className="font-bold text-sm text-color-000">
                                  {fullname}
                                </span>
                              </div>
                              {renderIf(
                                location_address,
                                <div className="flex items-center gap-x-1">
                                  <RiMapPinFill
                                    size={11}
                                    className="text-color-400"
                                  />
                                  <span className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                    {location_address}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      }}
                      handleChange={(e) => {
                        form.setValues({
                          ...form.values,
                          diocese: e.target,
                          diocese_name: e.target?.value,
                          diocese_id: e.target?.id,
                        })
                      }}
                    />
                  )}
                </Translate>
              )}
            </LayoutContext.Consumer>
          )
        },
      },
    ],
  },
  religious_order: {
    inline: true,
    className: 'grid grid-cols-1 gap-3',
    children: [
      {
        label: 'belong to religious order',
        name: 'religious_order',
        component: ({ name, value, onChange, form, ...restForm }) => {
          return (
            <LayoutContext.Consumer>
              {({ isSm }) => (
                <Translate>
                  {(t) => (
                    <LookupField
                      title={t('choose religious orders')}
                      createIfNotExists={true}
                      defaultValue={form?.values?.religious_order_name}
                      selectedOption={form?.values?.religious_order}
                      placeholder={t('click to select / create')}
                      apiPath={`/lookup/religious_order/get-by-types`}
                      name={name}
                      OptionWrapper={({ children, ...props }) => (
                        <div
                          className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative"
                          {...props}>
                          {children}
                        </div>
                      )}
                      renderOption={(o, i) => {
                        return (
                          <div
                            key={i}
                            className="flex items-center flex-1 gap-3">
                            <div
                              key={i}
                              className="flex items-center flex-1 gap-3">
                              <Avatar
                                size={60}
                                src={o.avatar}
                                icon={
                                  <ReligiousFillSvg
                                    size={30}
                                    className="text-color-500"
                                  />
                                }
                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                              />
                              <div className="flex flex-col gap-1 flex-1">
                                <span className="font-bold text-color-000 leading-tight">
                                  {o.name}
                                </span>
                                {renderIfElse(
                                  o?.religious_order_group,
                                  <span className="font-medium text-xs text-blue-500 italic">
                                    {o?.religious_order_group}
                                  </span>,
                                  <span className="text-xs text-color-400 italic max-lines-2">
                                    {o?.description}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        )
                      }}
                      handleChange={(e) => {
                        form.setValues({
                          ...form.values,
                          religious_order: e.target,
                          religious_order_name: e.target.value,
                          religious_order_id: e.target.id,
                        })
                      }}
                    />
                  )}
                </Translate>
              )}
            </LayoutContext.Consumer>
          )
        },
      },
    ],
  },
}

function validateName(name, requireField, keyName, t) {
  const error = {}
  const maxLengthConfig = {
    fullname: 120,
    patron_saint: 180,
    father_name: 255,
    mother_name: 255,
  }
  if (!name && !requireField) return error
  const maxLength = maxLengthConfig[keyName]
  const rules = [
    requireField ? required(t) : null,
    lengthBetween(2, maxLength, t),
    noNumber(t),
    noSpecialChars(t),
    noLeadingTrailingSpaces(t),
    noDoubleSpaces(t),
    firstLetterUppercase(t),
  ].filter(Boolean)
  const message = runRules(name, rules)
  if (message) {
    error[keyName] = message
  }
  return error
}

const validateEmail = (email, t) => {
  if (!email) return {}
  const rules = [lengthBetween(5, 120, t), emailFormat(t)]
  const error = runRules(email, rules)
  return error ? { contact_email: error } : {}
}

const validatePhoneNumber = (phone, keyName, t) => {
  if (!phone) return {}
  const rules = [digitLength(10, 16, t)]
  const error = runRules(phone, rules)
  return error ? { [keyName]: error } : {}
}

const validateAddress = (address, t) => {
  if (!address) return {}
  const rules = [
    lengthBetween(5, 500, t),
    noLeadingTrailingSpaces(t),
    noDoubleSpaces(t),
  ]
  const error = runRules(address, rules)
  return error ? { contact_address: error } : {}
}

const validateParishOrDioceseOrReligiousOrPlaceOfBirthName = (
  name,
  keyName,
  t
) => {
  const maxLengthConfig = {
    parish: 180,
    place_of_birth: 120,
    diocese: 255,
    religious_order: 255,
  }
  if (!name) return {}
  let maxLength = maxLengthConfig[keyName]
  const rules = [
    lengthBetween(2, maxLength, t),
    noNumber(t),
    noSpecialChars(t),
    noLeadingTrailingSpaces(t),
    noDoubleSpaces(t),
    parishFormart(t),
  ]
  const error = runRules(name, rules)
  return error ? { [keyName]: error } : {}
}

const validateIdentityOrDriverLisenceOrPassport = (value, type, t) => {
  if (!value) return { identifier_code: t('required') }
  const rules =
    type === 'identitycard' || type === 'driverlicense'
      ? [digitLength(12, 50, t)]
      : [passportFormart(t)]
  const error = runRules(value, rules)
  return error ? { identifier_code: error } : {}
}

const validateCreateAndEditStudent = (t) => (values) => {
  const {
    patron_saint,
    fullname,
    parish,
    diocese,
    religious_order,
    place_of_birth,
    identifier_type,
    identifier_code,
    contact_email,
    contact_phone,
    contact_address,
    father_name,
    mother_name,
    father_phone_number,
    mother_phone_number,
  } = values ?? {}
  const errorPatronSaint = validateName(
    patron_saint ? patron_saint.value : '',
    false,
    'patron_saint',
    t
  )
  const errorFullname = validateName(fullname, true, 'fullname', t)
  const errorParish = validateParishOrDioceseOrReligiousOrPlaceOfBirthName(
    parish ? parish.value : '',
    'parish',
    t
  )
  const errorDiocese = validateParishOrDioceseOrReligiousOrPlaceOfBirthName(
    diocese ? diocese.value : '',
    'diocese',
    t
  )
  const errorReligious = validateParishOrDioceseOrReligiousOrPlaceOfBirthName(
    religious_order ? religious_order.value : '',
    'religious_order',
    t
  )
  const errorIdentity = validateIdentityOrDriverLisenceOrPassport(
    identifier_code,
    identifier_type,
    t
  )
  const errorPlaceOfBirth =
    validateParishOrDioceseOrReligiousOrPlaceOfBirthName(
      place_of_birth,
      'place_of_birth',
      t
    )
  const errorEmail = validateEmail(contact_email, t)
  const errorPhoneNumber = validatePhoneNumber(
    contact_phone,
    'contact_phone',
    t
  )
  const errorAddress = validateAddress(contact_address, t)
  const errorFatherName = validateName(father_name, false, 'father_name', t)
  const errorMotherName = validateName(mother_name, false, 'mother_name', t)
  const errorFatherPhoneNumber = validatePhoneNumber(
    father_phone_number,
    'father_phone_number',
    t
  )
  const errorMotherPhoneNumber = validatePhoneNumber(
    mother_phone_number,
    'mother_phone_number',
    t
  )
  return {
    ...errorPatronSaint,
    ...errorFullname,
    ...errorParish,
    ...errorDiocese,
    ...errorReligious,
    ...errorPlaceOfBirth,
    ...errorIdentity,
    ...errorEmail,
    ...errorPhoneNumber,
    ...errorAddress,
    ...errorFatherName,
    ...errorMotherName,
    ...errorFatherPhoneNumber,
    ...errorMotherPhoneNumber,
  }
}

export const CreateStudentModal = ({
  owner_id,
  owner_type,
  onCancel = NullAsDefault,
  onSubmit = NullAsDefault,
}) => {
  const t = useTranslate()

  const initialValues = useMemo(() => {
    return {
      owner_id,
      owner_type,
      avatar: undefined,
      contact_email: undefined,
      identifier_type: 'identitycard',
      gender: 3,
      refreshKey: Date.now(),
    }
  }, [owner_id, owner_type])

  return (
    <Formik
      validate={validateCreateAndEditStudent(t)}
      validateOnMount={true}
      validateOnChange={true}
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(values) => {
        const { email, owner_id, owner_type, ...rest } = values ?? {}
        onSubmit(rest)
      }}>
      {({ values }) => {
        const { user, refreshKey } = values ?? {}

        return (
          <ActionModalWrapper action={<FormActionBar submitText="create" />}>
            <Pure input={[refreshKey]}>
              <div
                key={refreshKey}
                className="flex flex-col gap-6">
                <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <FaUserGraduate
                      size={20}
                      className="mr-2 text-color-500"
                    />
                    {t('student information')}
                  </div>
                  <div className="flex flex-col gap-3">
                    <FieldsFactory
                      formSchema={[
                        formSchema.patron_saint__fullname,
                        formSchema.id_validator,
                        formSchema.date__place_of_birth_gender,
                        formSchema.diocese_location,
                        formSchema.religious_order,
                      ]}
                    />
                  </div>
                </div>
                <div className="p-3 border-l-4 border-blue-600 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <FaPhone
                      size={18}
                      className="mr-2 text-blue-500"
                    />
                    {t('contact information')}
                  </div>
                  <div className="flex flex-col gap-3">
                    <FieldsFactory
                      formSchema={[
                        formSchema.contact_email__phone,
                        // formSchema.contact_email,
                        // formSchema.contact_phone,
                        formSchema.contact_address,
                      ]}
                    />
                  </div>
                </div>
                <div className="p-3 border-l-4 border-green-500 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <BsPeopleFill
                      size={22}
                      className="mr-2 text-green-500"
                    />
                    {t('parent information')}
                  </div>
                  <div className="flex flex-col gap-3">
                    <FieldsFactory
                      formSchema={[
                        formSchema.father_user,
                        formSchema.mother_user,
                      ]}
                    />
                  </div>
                </div>
              </div>
            </Pure>
          </ActionModalWrapper>
        )
      }}
    </Formik>
  )
}

export const EditStudentModal = ({
  item,
  owner_id,
  owner_type,
  onCancel = NullAsDefault,
  onSubmit = NullAsDefault,
}) => {
  const t = useTranslate()

  const initialValues = useMemo(() => {
    const { date_of_birth, avatar, ...rest } = item ?? {}

    return {
      ...rest,
      owner_id,
      owner_type,
      avatar_preview: avatar,
      date_of_birth: parseDayjs(date_of_birth),
      parish: _.get(rest, 'parish', ''),
      parish_id: _.get(rest, 'parish.id', ''),
      parish_name: _.get(rest, 'parish_name', ''),
      patron_saint: rest?.patron_saint,
      patron_saint_id: rest?.patron_saint?.id,
      patron_saint_name:
        rest?.patron_saint_name || rest?.patron_saint?.common_name,
      religious_order: rest?.religious_order,
      religious_order_id: rest?.religious_order?.id,
      religious_order_name:
        rest?.religious_order_name || rest?.religious_order?.title,
      place_of_birth: rest?.place_of_birth,

      father_user: rest?.father?.user,
      father_user_id: rest?.father?.user?.id,
      father_name: rest?.father?.user?.name || rest?.father?.name,
      father_phone_number: rest?.father?.user?.name || rest?.father?.phone,

      mother_user: rest?.mother?.user,
      mother_user_id: rest?.mother?.user?.id,
      mother_name: rest?.mother?.user?.name || rest?.mother?.name,
      mother_phone_number: rest?.mother?.user?.name || rest?.mother?.phone,
    }
  }, [item, owner_id, owner_type])

  // const validate = (values) => {
  //   let errors = {}
  //   const { fullname, contact_email } = values ?? {}
  //   if (_.isEmpty(fullname ?? '')) {
  //     errors.fullname = t('required field')
  //   }
  //   return errors
  // }

  return (
    <Formik
      validate={validateCreateAndEditStudent(t)}
      validateOnMount={true}
      validateOnChange={true}
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(values) => {
        const { email, owner_id, owner_type, ...rest } = values ?? {}
        const _values = {
          ...rest,
        }

        const changes = shallowDiff(_values, initialValues)
        onSubmit(
          _.omitBy(
            {
              ...changes,
            },
            _.isUndefined
          )
        )
      }}>
      {({ values }) => {
        const { user, refreshKey } = values ?? {}

        return (
          <Pure input={[refreshKey]}>
            <React.Fragment key={values?.refreshKey}>
              {/*<ForDevelop>*/}
              {/*  <ErrorSummaries />*/}
              {/*</ForDevelop>*/}
              <ActionModalWrapper
                action={<FormActionBar submitText="save" />}
                className="gap-4">
                <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <FaUserGraduate
                      size={20}
                      className="mr-2 text-color-500"
                    />
                    {t('student information')}
                  </div>
                  <div className="flex flex-col gap-3">
                    <FieldsFactory
                      formSchema={[
                        formSchema.patron_saint__fullname,
                        formSchema.id_validator,
                        formSchema.date__place_of_birth_gender,
                        formSchema.diocese_location,
                        formSchema.religious_order,
                      ]}
                    />
                  </div>
                </div>

                <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <BsPersonCircle
                      size={20}
                      className="mr-2 text-color-500"
                    />
                    {t('image')}
                  </div>
                  <FieldsFactory formSchema={[formSchema.avatar]} />
                </div>

                <div className="p-3 border-l-4 border-blue-600 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <FaPhone
                      size={18}
                      className="mr-2 text-blue-500"
                    />
                    {t('contact information')}
                  </div>
                  <FieldsFactory
                    formSchema={[
                      formSchema.contact_email__phone,
                      // formSchema.contact_email,
                      // formSchema.contact_phone,
                      formSchema.contact_address,
                    ]}
                  />
                </div>
                <div className="p-3 border-l-4 border-green-500 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <BsPeopleFill
                      size={22}
                      className="mr-2 text-green-500"
                    />
                    {t('parent information')}
                  </div>
                  <div className="flex flex-col gap-3">
                    <FieldsFactory
                      formSchema={[
                        formSchema.father_user,
                        formSchema.mother_user,
                      ]}
                    />
                  </div>
                </div>
              </ActionModalWrapper>
            </React.Fragment>
          </Pure>
        )
      }}
    </Formik>
  )
}

export const EditStudentPersonalForm = ({
  item,
  onCancel = NullAsDefault,
  onSubmit = NullAsDefault,
}) => {
  const t = useTranslate()

  const initialValues = useMemo(() => {
    const { date_of_birth, avatar, ...rest } = item ?? {}

    return {
      avatar_preview: avatar,
    }
  }, [item])

  const validate = (values) => {
    let errors = {}
    const { avatar } = values ?? {}
    if (_.isEmpty(avatar ?? '')) {
      errors.avatar = t('required field')
    }
    return errors
  }

  return (
    <Formik
      validate={validate}
      validateOnMount={true}
      validateOnChange={true}
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(values) => {
        const changes = shallowDiff(values, initialValues)
        onSubmit(
          _.omitBy(
            {
              ...changes,
            },
            _.isUndefined
          )
        )
      }}>
      {({ values }) => {
        const { user, refreshKey } = values ?? {}

        return (
          <Pure input={[refreshKey]}>
            <React.Fragment key={values?.refreshKey}>
              <ActionModalWrapper
                action={<FormActionBar submitText="save" />}
                className="gap-4">
                <div className="p-3 border-l-4 border-color-300 rounded-lg shadow">
                  <div className="mb-4 flex items-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                    <BsPersonCircle
                      size={20}
                      className="mr-2 text-color-500"
                    />
                    {t('image')}
                  </div>
                  <FieldsFactory formSchema={[formSchema.avatar]} />
                </div>
              </ActionModalWrapper>
            </React.Fragment>
          </Pure>
        )
      }}
    </Formik>
  )
}
